var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.buttonsContainer},[(_vm.isOAuth2)?_c('FlatActionButton',{attrs:{"action":_vm.handleAuthorizeClick,"buttonClass":[
      'btnCTA',
      'btnDefault',
      {
        'btn-primary': _vm.enableAuthorize
      },
    ],"data-test-id":"GenericScimConnectorNewConfigButtons_Authorize","disabled":!_vm.enableAuthorize,"loading":_vm.testButtonLoading,"text":"Authorize"}}):_c('FlatActionButton',{attrs:{"action":_vm.handleTestConnectionClick,"buttonClass":[
      'btnCTA',
      'btnDefault',
      {
        'btn-primary': !_vm.disableTest
      },
    ],"data-test-id":"GenericScimConnectorNewConfigButtons_testConnection","disabled":_vm.disableTest,"loading":_vm.testButtonLoading,"text":"Test Connection"}}),_c('FlatActionButton',{attrs:{"action":_vm.handleActivateButtonClick,"buttonClass":[
      'btnCTA',
      'btnDefault',
      {
        'btn-primary': !_vm.disableActivate
      },
    ],"data-test-id":"GenericScimConnectorNewConfigButtons_activate","disabled":_vm.disableActivate,"loading":_vm.activateButtonLoading,"text":"Activate"}}),_c('OauthCredentialsWarningModal',{attrs:{"showOauthModal":_vm.showOauthModal},on:{"close":_vm.handleModalClose,"continue":_vm.handleOauthModalContinue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }